import getAminoAcidDataForEachBaseOfDna from "./getAminoAcidDataForEachBaseOfDna";
export default function getAminoAcidStringFromSequenceString(sequenceString, { doNotExcludeAsterisk } = {}) {
  const aminoAcidsPerBase = getAminoAcidDataForEachBaseOfDna(
    sequenceString,
    true
  );
  const aaArray = [];
  let aaString = "";
  aminoAcidsPerBase.forEach((aa, index) => {
    if (!aa.fullCodon) {
      return;
    }
    if (!doNotExcludeAsterisk && index >= aminoAcidsPerBase.length - 3 && aa.aminoAcid.value === "*") {
      return;
    }
    aaArray[aa.aminoAcidIndex] = aa.aminoAcid.value;
  });
  aaString = aaArray.join("");
  return aaString;
}
